import {
  AdminMobileMenuDrawerHeader,
  StyledMobileMenu,
  StyledMobileNavigationContent,
} from './style';
import { useIntl } from 'react-intl';
import { Button, Icon } from 'ui';
import { useLocation, useNavigate } from 'react-router-dom';
import { MobileMenuDrawer } from 'ui/Drawer/Drawers/MobileMenuDrawer';
import { useState } from 'react';
import { useAuth } from 'hooks/useAuth';
import { routes } from 'config/config';
import { adminPath } from 'enums/adminRoutes';

import { menuItems, menuItemsAdmin } from 'config/menuItems';
import SidebarMenuItem from 'admin/components/DefaultLayout/Sider/SidebarMenuItem/SidebarMenuItem';

const AdminMobileMenu = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedKey, setSelectedKey] = useState<null | string>(null);
  const intl = useIntl();
  const navigate = useNavigate();
  const { user, can } = useAuth();
  const { pathname } = useLocation();

  const handleButtonClick = (key: string, action: () => void) => {
    if (selectedKey === key) {
      setSelectedKey(null);
    } else {
      setSelectedKey(key);
    }
    action();
    setIsMenuOpen(false);
  };

  const openCloseDrawer = () => {
    if (!isMenuOpen) {
      setIsMenuOpen(true);
    } else {
      setIsMenuOpen(false);
    }
  };

  return (
    <StyledMobileMenu>
      <div className={'mobile-menu-container'}>
        <div className={'mobile-menu-content'}>
          <div
            className={`mobile-menu-item ${selectedKey === 'beginning' ? 'selected' : ''}`}
          >
            <Button
              type={'text'}
              className={selectedKey === 'beginning' ? 'selected' : ''}
              label={intl.formatMessage({ id: 'navigation.beginning' })}
              icon={<Icon name="admin/admin-back-to-emarket" />}
              onClick={() =>
                handleButtonClick('beginning', () =>
                  navigate(routes.admin.beginning)
                )
              }
            />
          </div>

          <div
            className={`mobile-menu-item ${selectedKey === 'notifications' ? 'selected' : ''}`}
          >
            <Button
              type={'text'}
              className={selectedKey === 'notifications' ? 'selected' : ''}
              label={intl.formatMessage({ id: 'navigation.notifications' })}
              icon={<Icon name={'admin/admin-mobile-menu-notifications'} />}
              onClick={() =>
                handleButtonClick('notifications', () =>
                  navigate(routes.admin.notifications)
                )
              }
            />
          </div>
        </div>

        <div className={'mobile-menu-filter'}>
          <Button
            type={'text'}
            icon={
              isMenuOpen ? (
                <Icon
                  name={'mobile-admin-filter-close-button-icon'}
                  type={'filter-icon'}
                />
              ) : (
                <Icon name={'mobile-admin-menu-open-icon'} type={'filter-icon'} />
              )
            }
            onClick={() => openCloseDrawer()}
          />
        </div>

        <div className={'mobile-menu-content'}>
          <div
            className={`mobile-menu-item manufacturers ${selectedKey === 'transactions' ? 'selected' : ''}`}
          >
            <Button
              type={'text'}
              className={selectedKey === 'transactions' ? 'selected' : ''}
              label={intl.formatMessage({ id: 'navigation.transactions' })}
              icon={<Icon name={'admin/admin-mobile-menu-transactions'} />}
              onClick={() =>
                handleButtonClick('transactions', () =>
                  navigate(adminPath.farmTransactions())
                )
              }
            />
          </div>

          <div
            className={`mobile-menu-item ${selectedKey === 'business' ? 'selected' : ''}`}
          >
            <Button
              type={'text'}
              className={selectedKey === 'business' ? 'selected' : ''}
              label={intl.formatMessage({ id: 'general.profile' })}
              icon={<Icon name={'admin/admin-profile-icon'} />}
              onClick={() =>
                handleButtonClick('business', () => navigate(adminPath.business()))
              }
            />
          </div>
        </div>
      </div>

      <MobileMenuDrawer
        onClose={openCloseDrawer}
        open={isMenuOpen}
        closable={false}
        className={'mobile-menu-admin'}
        title={
          <AdminMobileMenuDrawerHeader className={'role'}>
            {user?.farmName}
          </AdminMobileMenuDrawerHeader>
        }
      >
        <StyledMobileNavigationContent>
          <div className={'mobile-navigation-block first'}>
            {menuItems.map((item, index) => {
              if (item?.ability && !can(item.ability)) {
                return null;
              }

              if (
                item.requiresWholesaleContract &&
                !user?.isAdmin &&
                !(user?.farm?.has_wholesale_contract ?? false)
              ) {
                return null;
              }

              return (
                <SidebarMenuItem
                  key={index}
                  labelId={intl.formatMessage({ id: item.labelId })}
                  url={item.url}
                  icon={item.icon}
                  badgeCount={item.badgeCount}
                  active={
                    pathname === item.url || pathname.startsWith(`${item.url}/`)
                  }
                  openCloseDrawer={openCloseDrawer}
                />
              );
            })}
          </div>
          <div className={'mobile-navigation-block second'}>
            {menuItemsAdmin
              .filter((item) => item.adminOnly === false || user?.isAdmin)
              .map((item, index) => (
                <SidebarMenuItem
                  key={index + 100}
                  labelId={intl.formatMessage({ id: item.labelId })}
                  url={item.url}
                  icon={item.icon}
                  badgeCount={item.badgeCount}
                  active={
                    pathname === item.url ||
                    pathname.startsWith(`${item.url}/`)
                  }
                  openCloseDrawer={openCloseDrawer}
                />
              ))}
          </div>
        </StyledMobileNavigationContent>
      </MobileMenuDrawer>
    </StyledMobileMenu>
  );
};

export default AdminMobileMenu;
